module.exports = __webpack_public_path__ + "static/media/taxation_law_icon.3bd83515.svg";